import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => {
  const commonBoxShadow =
    '0px 0px 9px 0px rgba(82, 94, 109, 0.20), 0px 0px 2px 0px rgba(82, 94, 109, 0.25), 1px 1px 1px 0px rgba(254, 254, 254, 0.10) inset';
  const commonPseudoElementStyles = {
    background: theme.new.color.common.white,
    borderBottomLeftRadius: '12px',
    borderBottomRightRadius: '12px',
    boxShadow: commonBoxShadow,
    content: '""',
    display: 'block',
    height: '10px',
    position: 'absolute' as const,
  };
  const commonListItemStyles = {
    background: theme.new.color.common.white,
    boxShadow: commonBoxShadow,
    alignItems: 'center',
    minHeight: '84px',
    borderRadius: '12px',
  };

  return {
    'rt--notifications--cmp--list--list-item--notification-item--list-item': {
      ...commonListItemStyles,
      marginBottom: '8px',

      '.MuiListItemSecondaryAction-root': {
        right: '16px',
        top: '26px',
      },
    },
    'rt--notifications--cmp--list--list-item--notification-item--no-notifications':
      {
        ...commonListItemStyles,
        flexFlow: 'column',
        height: '220px',
        justifyContent: 'center',
        marginBottom: '16px',
        padding: '16px',
      },
    'rt--notifications--cmp--list--list-item--notification-item--group-item': {
      ...commonListItemStyles,
      marginBottom: '24px',

      '&::before': {
        ...commonPseudoElementStyles,
        bottom: '-8px',
        left: '5px',
        width: 'calc(100% - 10px)',
        zIndex: -1,
      },

      '&::after': {
        ...commonPseudoElementStyles,
        bottom: '-16px',
        left: '10px',
        width: 'calc(100% - 20px)',
        zIndex: -2,
      },

      '.MuiListItemSecondaryAction-root': {
        right: '16px',
        top: '26px',
      },
    },
    notificationText: {
      '& a': {
        color: theme.new.color.brandPrimary,
        textDecoration: 'none',
      },
    },
    showMoreButtonWrapper: {
      position: 'absolute',
      right: '16px',
    },
    icon: {
      backgroundColor: theme.new.color.grey[100],
    },
    unRead: {
      backgroundColor: theme.new.color.brand['100'],
    },
    badge: {
      '& .MuiBadge-badge': {
        backgroundColor: theme.new.color.brand['600'], // Blue ellipse dot
        width: '8px',
        height: '8px',
        left: '12px',
      },
    },
    loadMoreContainer: {
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      marginTop: '12px',
      marginBottom: '8px',
    },
    loadMoreButtonWrapper: {
      backgroundColor: theme.new.color.pageBackground,
    },
    pagePopoverContext: {
      '& .MuiListItemSecondaryAction-root': {
        right: '0px',
        '& svg': {
          width: '24px',
          height: '24px',
          '& path': {
            stroke: theme.new.color.textSecondary,
          },
        },
      },
    },
  };
});
